import { v4 } from 'uuid';

export const useIdentifier = () => {

    const create = (): string => {
        let identifier = '';

        // We're generating 4 uuid's to make it harder to brute force (results in 144 characters)
        for (let i = 0; i < 4; i++) {
            identifier += v4();
        }

        return identifier;
    }

    return {
        create
    }
}
